module.exports = __webpack_public_path__ + "img/SKMJ_train4.3b7ff9c7.jpg";